import { render, staticRenderFns } from "./ContractServices.yaml?vue&type=template&id=498a3604&component"
import script from "./ContractServices.yaml?vue&type=script&lang=ts&component"
export * from "./ContractServices.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports